import { commonFunctions } from "../_utilities/commonFunctions"
import { config } from "../config"

export const matterService = {
    createMatterDetail,
    getMatterDetails,

}

function createMatterDetail(data)  {
    const extraHeaders = {
        "Content-Type": "application/json",
      };

      const requestOptions = commonFunctions.getRequestOptions(
        "POST",
        extraHeaders,
        JSON.stringify(data)
      );
    
    return fetch(`${config.localApiUrl}/api/createMatter`,
        requestOptions
    ).then((response) => response.json())
}

function getMatterDetails() {
    const requestOptions = commonFunctions.getRequestOptions(
        "GET"
    )
    return fetch(
        `${config.localApiUrl}/api/getMatter`,
        requestOptions
    ).then((response) => response.json())
}

// function createMatterDetail(formData)  {
//     const requestOptions = {
//         method: 'POST',
//         body: formData,
//     };
    
//     return fetch(`${config.localApiUrl}/api/createMatter`,
//         requestOptions
//     ).then((response) => response.json())
// }

